import { body2, caption, colors, fontSizes, spacing } from 'ui/theme';
import styled from 'styled-components';
import { Cell } from 'ui/tableCell';
import { pxToRem } from 'utils/convert';
import { Link } from 'ui/links';

export const NodeVisitorsTakeoverWrapper = styled.div`
  width: 100%;
`;

export const TableWrapper = styled.div`
  padding: ${spacing.half} 0px;
  outline: 1px solid ${colors.grey15};
  margin: ${spacing.half} ${spacing.base};
`;

export const StyledTableToolbar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${colors.secondaryText};
  margin: ${spacing.half} ${spacing.base};
`;

export const StyledToolbarActions = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.threeQuarter};
`;

export const StyledCell = styled(Cell)`
  height: ${pxToRem(64.5)};
`;

export const StyledCellContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${spacing.quarter};
  align-self: stretch;
`;

export const Email = styled(Link)`
  ${body2};
`;
export const CellSecondaryText = styled.div`
  ${colors.textSecondary}
  ${caption};
`;

export const CellText = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.half};
  align-self: stretch;
`;

export const StyledVisitor = styled.div`
  font-size: ${fontSizes.s14};
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;

export const StyledUserId = styled.div`
  color: ${colors.textSecondary};
`;
